import config from '@/config/config';
import { type CreateAxaInvoicingReportRequest } from '~/common/types/export/exportRequests';
import createRestClient from '../restClient';
import { type ExportFilterType } from '~/common/types/export/filter';
import { type PaginatedAutocomplete } from '~/common/types';

const client = createRestClient(config.baseURL);

const getCaseTypesAutocomplete = (
  params: Record<string, unknown>,
): Promise<PaginatedAutocomplete> => client.get('/export/case-type/autocomplete', { params });

const getExportTemplatesAutocomplete: (
  params: Record<string, unknown>,
) => Promise<PaginatedAutocomplete> = (params: Record<string, unknown>) =>
  client.get('/export/template/autocomplete', { params });

const getExportTemplate = ({ id, language }: { id: string; language: string }) =>
  client.get(`/export/template/${id}`, { params: { language } });

const createAxaInvoicingReport = (
  data: CreateAxaInvoicingReportRequest,
): Promise<undefined | ArrayBuffer> =>
  client.post('/export/axa-invoicing', data, { responseType: 'arraybuffer' });

const createExportTemplate = (data: Record<string, unknown>) =>
  client.post('/export/template', data);

const updateExportTemplate = (data: Record<string, unknown>) =>
  client.put('/export/template', data);

const getExportFiltersBySegment = (segment: string): Promise<ExportFilterType[]> =>
  client.get(`/export/filter/multiselect/${segment}`);

export default {
  createAxaInvoicingReport,
  createExportTemplate,
  getCaseTypesAutocomplete,
  getExportFiltersBySegment,
  getExportTemplate,
  getExportTemplatesAutocomplete,
  updateExportTemplate,
};
